import styled from 'styled-components';
import { mQ } from 'pages/styles/common';

export const AdditionalCommentsLayout = styled.div`
  margin: 32px auto;
  background: #fff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 10px;
  padding-left: 15px;
  padding-top: 32px;
  padding-bottom: 32px;
  ${mQ.md`
    margin-top: 0px;
    padding: 0 32px;
    box-shadow: unset;
  `}
`;

export const AdditionalCommentsLabel = styled.div`
  display: flex;
  text-align: left;
  font-size: 20px;
  color: #000000de;
`;

export const AdditionalCommentsData = styled.div`
  display: flex;
  text-align: left;
  font-size: 12pz;
  margin: 14px auto;
  color: #000;
`;
